// The dead end every not-found state shares: an unknown path, guide slug,
// property, or welcome guide. Each used to be a lone sentence on a bare cream
// page, so a mistyped URL landed somewhere that did not look like the site.
// This is the standard interior shell (masthead, heading slot, footer); the
// caller supplies the heading, the Seo title, and its own links as children.
import Footer from './Footer.jsx';
import Header from './Header.jsx';
import Seo from './Seo.jsx';

export default function NotFound({ title, seoTitle, children }) {
  return (
    <div className="mx-auto max-w-brief px-4 pt-6 sm:px-6">
      <Seo title={seoTitle} noindex />
      <Header />
      <div className="mt-8 border-b border-navy-100 pb-6">
        <h1 className="font-display text-3xl font-semibold text-navy-900 sm:text-4xl">
          {title}
        </h1>
        <p className="mt-2 text-navy-600">{children}</p>
      </div>
      <Footer />
    </div>
  );
}
